/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { GetStaticProps } from 'next'
import Link from 'next/link'
import { Post, PostItem } from '@/types/blog'
import { getPostAndMorePosts, getAllPostsForHome } from '@/service/blog'
import LayoutDefault from '@/components/layouts/Layout'
import ImgResponsive from '@/components/elements/ImgResponsive'
import DateRender from '@/components/elements/DateRender'
import Button from '@/components/elements/Button'
import SectionHeader from '@/components/modules/SectionHeader'
import TitleShadow from '@/components/modules/TitleShadow'
import classNames from 'classnames'

interface BlogPageProps {
  readonly posts: Post
  readonly hasLoadMore: boolean
}

export default function BlogPage({ posts, hasLoadMore }:BlogPageProps) {
  const [article, setArticle] = React.useState<PostItem[]>([])
  const heroPost = posts.edges.map((edge) => edge)
  const [haveMorePosts, setHaveMorePosts] = React.useState<boolean>(hasLoadMore)
  const [loading, setLoading] = React.useState(false)
  const [first, setFirst] = React.useState(9)
  const [startAt, setStartAt] = React.useState(posts?.pageInfo?.endCursor)

  const fetchMore = async (first: number, after: string) => {
    setLoading(true)
    const response = await getPostAndMorePosts(first, after)
    const { edges, pageInfo } = response
    const newPosts = edges.map((edge: any) => edge)
    setArticle([...article, ...newPosts])
    setFirst(first)
    setHaveMorePosts(pageInfo?.hasNextPage)
    setStartAt(pageInfo?.endCursor)
    setLoading(false)
  }

  React.useEffect(() => {
    if (article.length > 0) return
    setArticle(heroPost)
  }, [heroPost])

  return (
    <LayoutDefault image='https://twinsynergy.co.th/images/social-article.webp'>
      <SectionHeader
        title='article'
        bgColors='#1990FF'
        bgImage='/images/default_banner_header.webp'
        bgImageSm='/images/default_banner_header-sm.webp'
        bgImageWidth={1214}
        bgImageHeight={534}
      />
      <div className='container mx-auto px-4 pb-16 pt-32'>
        <TitleShadow
          prologue='อ่านฉันสิ'
          colorPrologue='#EFEFEF'
          title='โพสต์ล่าสุด'
          colorTitle='#000000'
        />
        <div className='my-6 grid grid-flow-row grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-4 lg:gap-8'>
          {article.map((post, index) => {
            const { databaseId, title, slug } = post.node
            const featuredCls = classNames('featured-image', {
              'md:col-span-2': (index + 1) % 5 === 0,
            })
            return (
              <div key={databaseId} className={featuredCls}>
                {post.node.featuredImage ? (
                  <Link href={`/${slug}`} prefetch={false}>
                    <ImgResponsive
                      className='w-full'
                      src={post.node.featuredImage.node.sourceUrl}
                      alt={title}
                      loadingLazy
                      style={{
                        aspectRatio: 87 / 49,
                      }}
                    />
                  </Link>
                ) : null}
                <div className='py-4 md:flex md:flex-col md:justify-between'>
                  <span className='small text-content-base'>
                    <DateRender type='long' date={post.node.date} />
                    {post.node?.categories &&
                      post.node?.categories?.edges &&
                      post.node?.categories?.edges.map((category) => (
                        <span className='badge badge-primary mx-2' key={category?.node && category?.node.slug}>
                          {category?.node && category?.node.name}
                        </span>
                      ))}
                  </span>
                  <h4 className='mb-4 text-lg font-semibold md:line-clamp-1'>
                    <Link href={`/${slug}`} prefetch={false}>{title}</Link>
                  </h4>
                  <div
                    dangerouslySetInnerHTML={{ __html: post.node.excerpt }}
                    className='line-clamp-2 text-sm text-content-base'
                  />
                  <Link className='mt-4 font-semibold' href={`/${slug}`} prefetch={false}>
                    อ่านทั้งหมด
                  </Link>
                </div>
              </div>
            )
          })}
        </div>
        {haveMorePosts ? (
          <div className='flex justify-center'>
            <Button
              htmlType='button'
              className='btn-primary'
              disabled={loading}
              onClick={() => fetchMore(first, startAt)}
            >
              {loading ? 'Loading...' : 'Load more'}
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    </LayoutDefault>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const posts = await getAllPostsForHome(9, '')

  return {
    props: {
      posts,
      hasLoadMore: posts?.pageInfo?.hasNextPage,
    },
  }
}
